import type { SelectHTMLAttributes } from 'react';

interface Option<T extends string> {
  value: T;
  label: string;
}

interface Props<T extends string>
  extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange' | 'value'> {
  label?: string;
  value: T;
  options: Option<T>[];
  onValueChange: (v: T) => void;
}

export function Select<T extends string>({
  label,
  value,
  options,
  onValueChange,
  className = '',
  ...rest
}: Props<T>) {
  return (
    <label className="block">
      {label && <span className="field-label">{label}</span>}
      <select
        {...rest}
        value={value}
        onChange={(e) => onValueChange(e.target.value as T)}
        className={`field-input ${className}`}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
